<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="120px"
      >
        <el-form-item
          label="章节/分类选择"
          prop="courseChapterId"
        >
          <el-cascader
            ref="cascader"
            v-model="cascaderInfo"
            :props="cascaderProps"
            :options="list"
            clearable
            @change="formatCourse"
          />
        </el-form-item>
        <el-form-item
          label="导入类型"
          prop="importType"
        >
          <el-radio-group v-model="createForm.importType">
            <el-radio :label="10">
              增量导入
            </el-radio>
            <el-radio :label="20">
              重置导入
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="导入文件"
          prop="fileName"
        >
          <el-upload
            ref="upload"
            action=""
            :on-change="changeFile"
            :on-remove="removeFile"
            :auto-upload="false"
            :limit="1"
            accept=".xls,.xlsx"
          >
            <el-button
              type="primary"
            >
              导入EXCEL
            </el-button>
          </el-upload>
          <el-input
            v-show="false"
            v-model="createForm.fileName"
          />
        </el-form-item>
      </el-form>
      <el-link
        :href="downloadUrl"
        target="_blank"
        type="primary"
        class="link"
      >
        模板下载
      </el-link>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

const config = require('../../../httpConfig');

export default {
  name: 'ImportExcelDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
    list: {
      type: [Array],
      default: () => [],
    },
    type: {
      type: Number,
      default: 10, // 10 课程 20 测评宝
    },
  },
  data() {
    return {
      title: '试题导入',
      cancelText: '取消',
      cascaderProps: {
        value: 'customizeId',
        label: 'customizeName',
        children: 'list',
      },
      file: {},
      cascaderInfo: '',
      createForm: {
        targetId: null,
        targetSonId: null,
        importType: 10,
        fileName: null,
        targetType: this.type,
      },
      creatRules: {
        targetSonId: [
          { required: true, message: '请选择课程章节/分类', trigger: 'change' },
        ],
        importType: [
          { required: true, message: '请选择导入类型', trigger: 'change' },
        ],
        fileName: [
          { required: true, message: '请选择文件', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    downloadUrl() {
      return `${process.env.VUE_APP_HOST_ENV === 'dev' ? config.dev : config.prod}/api/question/listExample`;
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.file = null;
          this.$refs.upload.clearFiles();
          this.createForm.fileName = null;
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    // 处理章节
    formatCourse() {
      if (this.$refs.cascader.getCheckedNodes().length > 0) {
        const targetSonId = this.cascaderInfo[1];
        const targetId = this.cascaderInfo[0];
        this.createForm = Object.assign(this.createForm, { targetSonId, targetId });
      } else {
        this.createForm = Object.assign(this.createForm, { targetId: null, targetSonId: null });
      }
    },
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const fileFormData = new FormData();
          fileFormData.append('file', this.file.raw, this.createForm.fileName);
          fileFormData.append('targetSonId', this.createForm.targetSonId);
          fileFormData.append('targetId', this.createForm.targetId);
          fileFormData.append('targetType', this.createForm.targetType);
          fileFormData.append('importType', this.createForm.importType);
          const data = await axClient.test.importExcel(fileFormData);
          if (!data) return;
          this.$message.success('导入成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
    changeFile(file) {
      this.file = file;
      this.createForm.fileName = file.name;
    },
    removeFile() {
      this.file = null;
      this.createForm.fileName = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .link{
    margin-top: -10px;
    float: right;
  }
}
</style>
